import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { C as CardHeaderStyled, E as ExpandButton } from './CardHeader.styles-Bhltj-5S.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { a as angleRight } from '../LocalModules/storm-ui-icons/dist/esm/classicIcons-Dl_q4l5f--kL9Y5b9.js';

const CardHeader = ({
  children,
  isCollapsed = false,
  onCollapse,
  padding,
  paddingInlineStart,
  paddingInlineEnd,
  paddingBlockStart,
  paddingBlockEnd,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('card-header')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(CardHeaderStyled, _extends({}, rest, {
  $isCollapsed: isCollapsed,
  $padding: padding,
  $paddingInlineStart: paddingInlineStart,
  $paddingInlineEnd: paddingInlineEnd,
  $paddingBlockStart: paddingBlockStart,
  $paddingBlockEnd: paddingBlockEnd
}), onCollapse && /*#__PURE__*/React__default.createElement(ExpandButton, _extends({}, getDataTaktAttributes(), {
  icon: angleRight,
  label: isCollapsed ? 'expand' : 'collapse',
  "aria-expanded": !isCollapsed,
  onClick: onCollapse,
  variant: "transparent",
  $expanded: !isCollapsed
})), /*#__PURE__*/React__default.createElement("div", null, children)));
CardHeader.displayName = 'CardHeader';

export { CardHeader as C };
//# sourceMappingURL=CardHeader-CBZ-1pZy.js.map
